const urls = {
  fetchReferralLink() {
    return `/shield/referral/link`;
  },
  saveReferralJoin() {
    return `/shield/referral/form-submit`;
  },
};

export default urls;
